import React from "react";
import { motion } from "framer-motion";

import gameConstants from "../../constants/game";

const ProgressRow = () => (
  <motion.div
    initial={{ opacity: 1 }}
    animate={{ opacity: 0, transitionEnd: { display: "none" } }}
    transition={{ delay: 2 }}
    className={`absolute left-0 top-0 z-50 flex h-full w-full items-center justify-evenly rounded bg-transparent text-2xl`}
  >
    {new Array(5).fill(0).map((_, index) => (
      <motion.div
        key={"square-" + index}
        initial={{ opacity: 1 }}
        animate={{
          opacity: 0,
          transition: {
            delay: 1.5,
          },
        }}
        className={` overflow-hidden `}
      >
        <motion.img
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: index * 0.3 }}
          className={`my-0.5 h-full w-8`}
          alt={gameConstants.journeySvgs[index].imgAlt}
          src={gameConstants.journeySvgs[index].imgSrc?.toLowerCase()}
        />
      </motion.div>
    ))}
  </motion.div>
);

export default ProgressRow;
